import React, { useEffect } from 'react';
import { BodyText } from '@paypalcorp/pp-react';
import { AMPLITUDE } from '../../../lib/constants';
import PropTypes from 'prop-types';

const NoResultModal = props => {
  const { content = {}, fptiClick } = props;

  const { SEARCH_MODAL_RESULT_NOT_FOUND } = AMPLITUDE;

  useEffect(
    () =>
      fptiClick({
        pageLink: 'search_modal',
        amplitude: true,
        event_name: SEARCH_MODAL_RESULT_NOT_FOUND
      }),
    []
  );

  return (
    <div className="no-result-modal">
      <img
        src={content.modalSearchImgUrl}
        alt="no result"
        width="150"
        height="150"
      />
      <BodyText size="md" medium>
        {content.searchBody}
      </BodyText>
    </div>
  );
};
NoResultModal.propTypes = {
  content: PropTypes.object,
  fptiClick: PropTypes.func
  //results: PropTypes.array
};
export default NoResultModal;
